import { render } from "./FileInput.vue?vue&type=template&id=65d7cf30&scoped=true&ts=true"
import script from "./FileInput.ts?vue&type=script&lang=ts"
export * from "./FileInput.ts?vue&type=script&lang=ts"

import "./FileInput.vue?vue&type=style&index=0&id=65d7cf30&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d7cf30"]])

export default __exports__